module.exports = __webpack_public_path__ + "static/media/actual-arrow-left-rounded.d3424d1b.svg";